import React from "react";
import PropTypes from "prop-types";
import { LayoutGrid, LayoutGridCell } from "@cdk-uip/react-layout-grid";
import { Card, CardHeader, CardTitle, CardText } from "@cdk-uip/react-card";
import { SystemMessage } from "@cdk-uip/react-system-messages";
import { PageSpinner } from "@cdk-uip/react-page-spinner";
import { Form } from "@cdk-uip/react-form";
import { TextField, TextFieldHelperText } from "@cdk-uip/react-text-field";
import { Button } from "@cdk-uip/react-button";
import {
  LOGIN_LINK,
  PARTNER_LOGIN_LINK,
  CVR_LOGIN_LINK,
} from "../config/ValidationPatterns";
import { CaptionText } from "@cdk-uip/react-typography";
import getBrand from "../config/Brand";

import ReactGA from "react-ga";

const brand = getBrand();

class RegistrationValidateEmail extends React.Component {
  constructor(props) {
    super(props);
    this.state = { email: "", invalidEmail: false };
    ReactGA.pageview("registration-start");
  }

  formSubmit = () => {
    if (this.state.invalidEmail === false) {
      this.props.validateEmail({
        email: this.state.email,
        domain: brand.short,
      });
    }
  };

  checkForSpecialChars = (inputText) => {
    let badChars = /[ !#$%^&*()+=[\]{};':"\\|,<>/?]/;
    let result = badChars.test(inputText);
    return result;
  };

  render() {
    return (
      <LayoutGrid>
        {this.props.validateEmailError && (
          <React.Fragment>
            {ReactGA.pageview("email-validation-error")}
            <LayoutGridCell
              spanDesktop={3}
              spanTablet={1}
              spanPhone={0}
            ></LayoutGridCell>
            <LayoutGridCell span={6}>
              <SystemMessage critical id="error-message">
                {this.props.validateEmailError}
              </SystemMessage>
            </LayoutGridCell>
            <LayoutGridCell
              spanDesktop={3}
              spanTablet={1}
              spanPhone={0}
            ></LayoutGridCell>
          </React.Fragment>
        )}
        <LayoutGridCell
          spanDesktop={3}
          spanTablet={1}
          spanPhone={0}
        ></LayoutGridCell>
        <LayoutGridCell
          align="middle"
          spanDesktop={6}
          spanTablet={6}
          spanPhone={4}
        >
          {this.props.validateEmailProcessing ? (
            <PageSpinner show={this.props.validateEmailProcessing} />
          ) : (
            <Card>
              {this.props.validateEmailCode === 0 &&
                this.props.validateEmailResult === true && (
                  <React.Fragment>
                    {ReactGA.pageview("email-verification-sent")}
                    <CardHeader>
                      <CardTitle large>Email verification sent</CardTitle>
                    </CardHeader>
                    <CardText>
                      <div id="verification-sent">
                        We have sent you a verification email. <br />
                        Please check your inbox and click on the link in the
                        email to verify your email address. If you don't see the
                        verification email please check your junk/spam folder.
                      </div>
                    </CardText>
                  </React.Fragment>
                )}
              {this.props.validateEmailCode === 1 && (
                <React.Fragment>
                  {ReactGA.pageview("email-verification-resent")}
                  <CardHeader>
                    <CardTitle large>Email verification resent</CardTitle>
                  </CardHeader>
                  <CardText>
                    <div id="verification-resent">
                      We have sent you another verification email.
                      <br />
                      Please check your inbox and click on the link in the email
                      to verify your email address. If you don't see the
                      verification email please check your junk/spam folder.
                      <br />
                      Please note any previous verification emails received will
                      no longer be valid.
                    </div>
                  </CardText>
                </React.Fragment>
              )}
              {this.props.validateEmailCode === 2 && (
                <React.Fragment>
                  {ReactGA.pageview("email-already-registered")}
                  <CardHeader>
                    <CardTitle large>
                      Your email address has already been registered
                    </CardTitle>
                  </CardHeader>
                  <CardText>
                    <div id="email-already-registered">
                      {this.props.validateEmailUserRole === "partner" ? (
                        <React.Fragment>
                          Click <a href={PARTNER_LOGIN_LINK}>here</a> to go to
                          the login page.
                          <br />
                          If you have forgotten your password or are having
                          trouble logging in please follow the steps on the
                          login page.
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          {brand.short === "CVR" ? (
                            <React.Fragment>
                              Click <a href={CVR_LOGIN_LINK}>here</a> to go to
                              the login page.
                              <br />
                              If you have forgotten your password or are having
                              trouble logging in please follow the steps on the
                              login page.
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              Click <a href={LOGIN_LINK}>here</a> to go to the
                              login page.
                              <br />
                              If you have forgotten your password or are having
                              trouble logging in please follow the steps on the
                              login page.
                            </React.Fragment>
                          )}
                        </React.Fragment>
                      )}
                    </div>
                  </CardText>
                </React.Fragment>
              )}
              {this.props.validateEmailResult !== true &&
                this.props.validateEmailCode !== 1 &&
                this.props.validateEmailCode !== 2 && (
                  <React.Fragment>
                    <CardHeader>
                      <CardTitle large>{brand.title}</CardTitle>
                    </CardHeader>
                    <CardText>
                      To begin the registration process please provide your
                      email address.
                      <Form onSubmit={() => this.formSubmit()}>
                        <div style={{ maxWidth: "450px" }}>
                          <TextField
                            fullWidth
                            label="Your email address"
                            type="email"
                            value={this.state.email}
                            required
                            invalid={this.state.invalidEmail}
                            validateOnKeyUp
                            onChange={(e) => {
                              this.setState({
                                email: e.target.value,
                                invalidEmail: this.checkForSpecialChars(
                                  e.target.value
                                ),
                              });
                              this.props.clearValidateEmailError();
                            }}
                            helperText={
                              <TextFieldHelperText validation>
                                Please enter a valid email address.
                              </TextFieldHelperText>
                            }
                          />
                        </div>

                        <Button type="submit" raised primary>
                          Validate Email
                        </Button>
                      </Form>
                      <br />
                      <CaptionText>
                        Please note: to complete the registration process, you
                        will need to provide your Bill-To account number, last
                        invoice number and invoice amount.
                      </CaptionText>
                    </CardText>
                  </React.Fragment>
                )}
            </Card>
          )}
        </LayoutGridCell>
      </LayoutGrid>
    );
  }
}

RegistrationValidateEmail.propTypes = {
  validateEmail: PropTypes.func.isRequired,
  validateEmailError: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
    .isRequired,
  validateEmailCode: PropTypes.number.isRequired,
  validateEmailProcessing: PropTypes.bool.isRequired,
  validateEmailResult: PropTypes.bool,
};

export default RegistrationValidateEmail;
